module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/logos/LCC-e1e82df135857980d2ff9888155266d6.png";